"use strict";
var Observable_1 = require('../../Observable');
var share_1 = require('../../operator/share');
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/share.js
// module id = 405
// module chunks = 4